export const HANDLE_AUTOMATIC_TESTING_CHANGE =
  'HANDLE_AUTOMATIC_TESTING_CHANGE';

export const handleAutomaticTestingChange = (value) => {
  return {
    type: HANDLE_AUTOMATIC_TESTING_CHANGE,
    value
  };
};
